import { getDetailsFromUrl } from "../services/blueprint";
import store from "../store";


const LOGGING_ENDPOINT = "https://your-domain.com/api/logs"; // nginx endpoint

const parseErrorStack = (stack) => {
    if (!stack) return {};
    console.log("stack---", stack)
    const stackLines = stack.split("\n");
    const relevantLine = stackLines.find((line) =>
        line.match(/https?:\/\/.*:\d+:\d+/)
    );

    if (!relevantLine) return {};

    const match = relevantLine.match(/(https?:\/\/.*):(\d+):(\d+)/);
    if (!match) return {};

    const [, file, line, column] = match;
    return { file, line: Number(line), column: Number(column) };
};

const sendLog = async (logEntry) => {
    try {
        // For security, configure an Elasticsearch URL with an API key in Nginx and use that secured endpoint.

        // const response = fetch(LOGGING_ENDPOINT, {
        //   method: "POST",
        //   headers: { "Content-Type": "application/json" },
        //   body: JSON.stringify(logEntry),
        // });

        // if (!response.ok) {
        //   console.error("Failed to send log:", await response.text());
        // }
    } catch (error) {
        console.error("Logger error:", error);
    }
};

const createLogger = (level) => async ({
    message,
    metaData = {},
}) => {

    const state = store.getState();
    const username = state?.auth?.loggedInUsername;
    const version = state?.global?.buildVersion?.build;
    const { blueprintId } = getDetailsFromUrl();
    const timestamp = new Date().toISOString();

    let finalMessage = message;
    let extraMeta = { ...metaData };

    finalMessage = message instanceof Error ? message.message : message;

    // commented due to file name and line number is not getting from stack
    // extraMeta.stack = message.stack ? message.stack : new Error().stack;
    // const { file, line, column } = parseErrorStack(message.stack);
    // if (file) {
    //     extraMeta.file = file;
    //     extraMeta.line = line;
    //     extraMeta.column = column;
    // }

    console.log(`[${timestamp}] [${level.toUpperCase()}] [${username || 'anonymous'}] [${blueprintId || 'nil'}] ${finalMessage}`)

    const logEntry = {
        timestamp,
        message: finalMessage,
        blueprintId: blueprintId || 'nil',
        username: username || 'anonymous',
        level,
        metaData: extraMeta,
        origin: 'client',
        hostname: window.location.hostname || 'nil',
        version: version || 'nil',
    };

    await sendLog(logEntry);
};


export const logInfo = createLogger("info");
export const logWarn = createLogger("warn");
export const logError = createLogger("error");
export const logDebug = createLogger("debug");
